/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_WarningInputs */

const en_delete_warning = /** @type {(inputs: Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this?`)
};

const nl_delete_warning = /** @type {(inputs: Delete_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet u zeker dat u dit wilt verwijderen?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this?" |
*
* @param {Delete_WarningInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const delete_warning = /** @type {((inputs?: Delete_WarningInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_WarningInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_delete_warning(inputs)
	return en_delete_warning(inputs)
});